import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import { cn } from '@/lib/utils'
import {
  SearchableSelect,
  SearchableSelectOption,
} from '../components/SearchableSelect'
import { Label } from '../primitives/Label'

interface DefaultItem {
  id: string | number
  name: string
  description?: string
  observations?: string
  code?: string
}

interface FormSearchableSelectProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  label?: string
  placeholder?: string
  searchPlaceholder?: string
  emptyMessage?: string
  fetcher: (_search: string) => Promise<SearchableSelectOption[]>
  rules?: Record<string, unknown>
  disabled?: boolean
  className?: string
  showLabel?: boolean
  multiple?: boolean
  defaultValue?: DefaultItem | DefaultItem[] | string | number | null
  dropdownPosition?: 'top' | 'bottom' | 'auto'
}

export function FormSearchableSelect<T extends FieldValues>({
  control,
  name,
  label,
  placeholder = 'Seleccionar...',
  searchPlaceholder = 'Buscar...',
  emptyMessage = 'No se encontraron resultados',
  fetcher,
  rules,
  disabled = false,
  className,
  showLabel = true,
  multiple = false,
  defaultValue,
  dropdownPosition = 'bottom',
}: FormSearchableSelectProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <div className={cn('flex flex-col gap-2', className)}>
          {showLabel && label && (
            <Label htmlFor={name} required={!!rules?.required}>
              {label}
            </Label>
          )}
          <SearchableSelect
            className={className}
            defaultValue={defaultValue}
            disabled={disabled}
            dropdownPosition={dropdownPosition}
            emptyMessage={emptyMessage}
            error={fieldState.error?.message}
            fetcher={fetcher}
            multiple={multiple}
            name={name}
            onChange={(value) => {
              field.onChange(value)
            }}
            placeholder={placeholder}
            searchPlaceholder={searchPlaceholder}
            value={field.value}
          />
        </div>
      )}
      rules={rules}
    />
  )
}
